var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-white text-5xl mt-20 h-20",style:({ maxWidth: `${_vm.maxWidth}px` })},[_c('div',{staticClass:"conferenceRoomNameContainer text-center"},[_c('div',{staticClass:"itemName",class:{ conferenceRoomName: _vm.hasOverflow }},[_vm._v("\n            "+_vm._s(_vm.roomName)+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }